function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    }); 
    return vars;
}
 

function getUrlParam(parameter, defaultvalue){
    var urlparameter = defaultvalue;
    if(window.location.href.indexOf(parameter) > -1){
        urlparameter = getUrlVars()[parameter];
    }
    return urlparameter;  
}  


jQuery(document).ready(function(){ 
  
  var has = getUrlParam('check','0'); 
    var n = window.location.href.indexOf("_step"); 
  var distributor = jQuery('#distributor').val();
   
  
  console.log(has+'=='+n+'=='+distributor);
  if(has != '0'){
    $( "tr.product" ).each(function( index ) {
    if(!$( this ).data('product-id')){      
      //$( this ).find('.product-thumbnail__wrapper').css('padding', '2px');
      $( this ).find('.product-thumbnail__wrapper img').attr('src','https://cdn.shopify.com/s/files/1/0542/2249/t/81/assets/ca-tax.jpeg?v=1585797175');
    }
	});
    jQuery('[name="checkout[remember_me]"]').parent().parent().parent().parent().hide();
  } 
    
    jQuery('#checkout, [action="/checkout"] .action_button, [action="/cart"] [name="checkout"], .mcheck').click(function(e){
      
      var discount=jQuery.cookie('tdis');
      if (discount != null)
      {
        discount=discount;
      }
      else
      {
        discount=0;
      }
      console.log(discount);
   	  e.preventDefault();
    	//console.log("disval----"+distributer);
      if(!distributor){ 
        if((jQuery('#aterms').prop("checked") == true) && (jQuery(".vcone").is(":checked") == true) && (jQuery(".vctwo").is(":checked")== true)){
            jQuery('body').addClass('loadersssss'); 
            /* Read Cart Line Items*/
            jQuery.getJSON('/cart.js', function(cart) {
              console.log(cart.items);
              jQuery('body').removeClass('loadersssss');
              var total_items = cart.items;
              var total_sin_items = parseInt(0);
              var all_variants = '';
              var all_titles = '';
              var i; 
              for (i = 0; i < total_items.length; i++) {

                //console.log(total_items[i].handle);
                var thisPrdTitleX = total_items[i]. product_title;
                var thisPrdhandle = total_items[i].handle;
                var thisPrdVariantID = total_items[i].variant_id;
                var thisPrdsku = total_items[i].sku;
                var thisPrdQtyX = total_items[i].quantity;
                
                 var prp = total_items[i].properties;
                 prp=  btoa(JSON.stringify(prp));
 
                //if this product has sin tax, add this variant to devsnest-cart-items-variants
                if(all_variants == ''){
                  all_variants = thisPrdVariantID+'__'+thisPrdTitleX+'__'+thisPrdQtyX+'__'+prp+'__'+thisPrdsku;
                 // all_variants = thisPrdVariantID+'__'+thisPrdTitleX+'__'+thisPrdQtyX;
                }else{
                  all_variants = all_variants+'|'+thisPrdVariantID+'__'+thisPrdTitleX+'__'+thisPrdQtyX+'__'+prp+'__'+thisPrdsku;
                 //  all_variants = all_variants+'|'+thisPrdVariantID+'__'+thisPrdTitleX+'__'+thisPrdQtyX;
                } 
 
              }  
              
              //store cart info
              jQuery('#devsnest-cart-items-variants').text(all_variants);

              var modal = document.getElementById("myModal");
              modal.style.display = "block";
              var span = document.getElementById("closenew");
              span.onclick = function() {
              modal.style.display = "none";
              }

              jQuery('#country').change(function(){
                if(jQuery('#country').val()=='United States'){
                  jQuery('.forstate').show();
                }else{
                  jQuery('.forstate').hide();
                }
              });

              jQuery('#okbutton').click(function(e){
                e.preventDefault();
                
                localStorage.removeItem('country');
                localStorage.removeItem('location');

                if(jQuery('#country').val() == ''){

                  alert('Please Select a Country');
                  return false;

                }else{

                  if(jQuery('#country').val()=='United States'){

                    if(jQuery('#location').val()==''){

                      alert('Please Select a State');
                      return false;

                    }else{

                      modal.style.display = "none";
                      jQuery('body').addClass('loadersssss');

                    }

                  }else{

                      modal.style.display = "none";              
                      jQuery('body').addClass('loadersssss');

                  }

                } 

                //setCookie('country',jQuery('#country').val(),100);
                //setCookie('location',jQuery('#location').val(),100);
                localStorage.setItem('country',jQuery('#country').val());
                localStorage.setItem('location',jQuery('#location').val());
                var country = jQuery('#country').val();
                var country_code = jQuery('#country option[value="'+jQuery('#country').val()+'"]').data('code');
                var location = jQuery('#location').val();
                if(jQuery('#country').val() == 'United States' && location== 'CA'){
                  console.log("posting")
                  $.ajax({
                    type: 'POST', 
                    url: "https://tax.riversupplyco.com/nicotinedevsku/draft-order.php",
                    data: {'srtingdata':all_variants,'country': country,'location':location,'country_code':country_code,'dis':discount},
                    success: function(resultData) {  
                      jQuery('body').removeClass('loadersssss');
                      var obj = jQuery.parseJSON(resultData);
                      console.log(obj); 
                      //console.log(obj.draft_order.invoice_url+'?check=1');
                      window.location.href = obj.draft_order.invoice_url+'?check=1';     
                    },
                    error: function(XMLHttpRequest, textStatus, errorThrown) { 
                      modal.style.display = "none";
                    } 

                  });
                }else{
                 
                  
                  document.location.href = '/checkout'; 
                }

              });

            });
        }else{
          	alert('You should accept our terms and conditions first.');        
        	return false;
        }
        
        return false;
        
      }else{ 
         
        
        /*if user is distributer */
        console.log("isdistrib");
        if((jQuery('#aterms').prop("checked") == true) && (jQuery(".vcone").is(":checked") == true) && (jQuery(".vctwo").is(":checked")== true)){
          var modal = document.getElementById("myModal");
              modal.style.display = "block";
              var span = document.getElementById("closenew");
              span.onclick = function() {
              modal.style.display = "none";
              }
              
               jQuery('#country').change(function(){
                if(jQuery('#country').val()=='United States'){
                  jQuery('.forstate').show();
                }else{
                  jQuery('.forstate').hide();
                }
              });
          
           jQuery('#okbutton').click(function(e){
                e.preventDefault();
                
                localStorage.removeItem('country');
                localStorage.removeItem('location');

                if(jQuery('#country').val() == ''){

                  alert('Please Select a Country');
                  return false;

                }else{

                  if(jQuery('#country').val()=='United States'){

                    if(jQuery('#location').val()==''){

                      alert('Please Select a State');
                      return false;

                    }else{

                      modal.style.display = "none";
                      jQuery('body').addClass('loadersssss');

                    }

                  }else{

                      modal.style.display = "none";              
                      jQuery('body').addClass('loadersssss');

                  }

                } 

                //setCookie('country',jQuery('#country').val(),100);
                //setCookie('location',jQuery('#location').val(),100);
                localStorage.setItem('country',jQuery('#country').val());
                localStorage.setItem('location',jQuery('#location').val());
                var country = jQuery('#country').val();
                var country_code = jQuery('#country option[value="'+jQuery('#country').val()+'"]').data('code');
                var location = jQuery('#location').val();
                document.location.href = '/checkout'; 

              });
          
        	 return true;
        }
        
      }
      
    });
    
  
  
  jQuery(".fieldset").show();
    if(localStorage.getItem('country') != 'Other'){
      
      jQuery('select#checkout_shipping_address_country').val(localStorage.getItem('country')).trigger('change');
      //if(localStorage.getItem('country') == 'United States'){
        jQuery('select#checkout_shipping_address_country').css('pointer-events', 'none');
      //}
      console.log(window.Countries);
      var html = '<option value="">State</option>';
      var country = localStorage.getItem('country');
      var location = localStorage.getItem('location');
      
      jQuery.each(window.Countries, function (key, data) {
        if(key == country){
            if(data.hasOwnProperty("provinces")){
                jQuery('[data-address-field="province"]').removeClass('hidden');
                jQuery('#checkout_shipping_address_province').removeAttr('disabled');
                jQuery('[data-address-field="zip"]').removeClass('field--half').addClass('field--third');
                jQuery.each(data, function (index, data1) {			
                    if(index == "provinces"){
                        //console.log('index', data1);				
                        jQuery.each(data1, function (index1, data2) {
                          var selected = '';
                          if(data2.code == location){ selected='selected';}
                            html += '<option data-alternate-values="[&quot;'+index1+'&quot;]" value="'+data2.code+'" '+selected+'>'+index1+'</option>';

                        });
                    }
                });
              
                console.log(html);	
                console.log(location);
              
                //if(html!=''){
                //html = '<option disabled="">State</option>'+html;
                jQuery('#checkout_shipping_address_province').html('');
                jQuery('#checkout_shipping_address_province').html(html);

                if(country == 'United States'){
                  jQuery('select#checkout_shipping_address_province').css('pointer-events', 'none');
                }

                //}

            }else{
                jQuery('[data-address-field="province"]').addClass('hidden');
                jQuery('#checkout_shipping_address_province').attr('disabled','disabled');
                jQuery('[data-address-field="zip"]').removeClass('field--third').addClass('field--half');
            }
        }
      });
    }else{
        jQuery('select#checkout_shipping_address_country [value="United States"]').remove();        
    }
  
}); 